export enum EventDetailsColumnType {
    Video = 0,
    Animation = 1,
    Stats = 2,
}
